import { Col, Flex, Form,  message, Row } from "antd";
import React from "react";
import {
  CustomButton,
  CustomParagraph,
  CustomSelect,
  CustomTitle,
} from "../../../components";
import MetricsCustomInput from "../../../components/MetricsCustomInput";
import { metricsTimePeriod } from "../../../common/static_data";
import { sendtMetrics } from "../../../api's/homeAPI";
import { useNavigate } from "react-router-dom";
import { useToken } from "../../../common/helper";

const MetricsForm = ({ selectedMetircData, closeModal, onSuccess }) => {

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { token, removeToken, getUserID } = useToken();
  const getSuffix = (title) => {
    if (title === "Shipments") return "";
    if (title === "Median transit time") return "hr";
    return "%";
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const handleReset = () => {
    // form.setFieldsValue({ target_value: 0 }); 
    let model = {
      target_value: 0,
      target_key: selectedMetircData?.target_key || null,
    };

    if (selectedMetircData?.title === "Shipments") {
      model.shipment_target_time_period = "month";
    }

    handleSetTargetMetrics(model)
  }

  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      const model = {
        ...values,
        target_key: selectedMetircData?.target_key || null,
      };
      handleSetTargetMetrics(model);
    }
  };

  const handleSetTargetMetrics = (model) => {
    sendtMetrics(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
            form.resetFields();
            onSuccess();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      });
  };

  return (
    <Form 
    form={form} 
    layout="vertical" 
    onFinish={onFinish} 
    initialValues={{
      target_value: selectedMetircData?.input_target_value ? selectedMetircData?.input_target_value : selectedMetircData?.target_value || selectedMetircData?.target_value|| null,
      shipment_target_time_period: selectedMetircData?.shipment_target_time_period || null,
    }}>
      <Row gutter={16}>
      <Col xs={24} sm={24} md={14}>
          <CustomParagraph
            text={"Target"}
            fontSize={12}
            fontWeight={600}
            lineHeight={"16px"}
            marginBottom={4}
            color={"#000"}
          />
          <Form.Item
            name="target_value"
            rules={[
              {
                required: false,
                message: "Please enter a value",
              },
              {
                pattern:
                  selectedMetircData?.title === "Shipments"
                    ? /^\d{1,7}$/
                    : /^\d{1,7}(\.\d{1,6})?$/,
                message:
                  selectedMetircData?.title === "Shipments"
                    ? "Only whole numbers allowed (up to 7 digits)"
                    : "Only numbers allowed (max 7 digits and 6 decimals)",
              },
            ]}
            
          >
            <MetricsCustomInput
              placeholder="00"
              height="36px"
              width={"100%"}
              border="0px"
              bgColor="#F3F3F3"
              textColor="#5E5E5E"
              borderRadius="6px"
              placeholderColor="#5E5E5E"
              lineHeight="38px"
              suffix={`${getSuffix(selectedMetircData?.title)} ${
                selectedMetircData?.title
              }`}
            />
          </Form.Item>
        </Col>

        {selectedMetircData?.title === "Shipments" && (
         <Col xs={24} sm={24} md={10}>
            <CustomTitle
              text="Time period"
              fontSize="12px"
              fontWeight="600"
              lineHeight="16px"
              color="black"
              marginBottom="4px"
            />
            <Form.Item
              name="shipment_target_time_period"
              rules={[{ required: true, message: "Please select a time period" }]}
            >
              <CustomSelect
                placeholder="Select"
                fontSize={10}
                lineHeight={"16px"}
                fontWeight="600"
                border="0px"
                bgColor={"#F3F3F3"}
                borderRadius={"6px"}
                boxShadow={"none"}
                height="36px"
                width="100%"
                options={metricsTimePeriod}
              />
            </Form.Item>
          </Col>
        )}
      </Row>

      <Flex
        style={{
          position: "sticky",
          bottom: "0",
          paddingTop: "28px",
        }}
        gap={8}
        justify="flex-end"
      >
        <CustomButton
          text="Reset"
          onClick={handleReset}
          width={60}
          height={40}
          bgColor="#fff"
          color="#000"
          fontSize={14}
          fontWeight={600}
          borderRadius={8}
          boxShadow={"none"}
        />
        <CustomButton
          text="Save"
          htmlType="submit"
          width={60}
          height={40}
          bgColor="#000"
          color="#fff"
          fontSize={14}
          fontWeight={600}
          borderRadius={8}
          boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.27)"
        />
      </Flex>
    </Form>
  );
};

export default MetricsForm;
